import { render } from "./StockReserved.vue?vue&type=template&id=a336b644&scoped=true"
import script from "./StockReserved.vue?vue&type=script&lang=js"
export * from "./StockReserved.vue?vue&type=script&lang=js"

import "./StockReserved.vue?vue&type=style&index=0&id=a336b644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a336b644"]])

export default __exports__